// middleware
import { changeVehicleConfiguration } from '../activities/change-vehicle';
import { navigationMiddleware } from '../middleware/navigationMiddleware';
import { postBootstrapMiddleware } from '../middleware/postBootstrapMiddleware';
import { toggleStatsMiddleware } from '../middleware/toggleStatsMiddleware';

export const getRemainingMiddleware = () => {
    return [postBootstrapMiddleware, navigationMiddleware, toggleStatsMiddleware, changeVehicleConfiguration.middleware];
};
